rjm.ui.ChartBuilderContainerView = Backbone.View.extend(

  initialize: (options) ->
    if not options.hasOwnProperty("chartModel") or 
        not options.hasOwnProperty("isCreate") or
        not options.hasOwnProperty("clientId") or
        not options.hasOwnProperty("gaConnectionsCollection")
      throw "InvalidConstructorArgs - ChartBuilderContainerView"

    _.bindAll this, "initializeSubviews", "renderCohortOptions", "renderStandardOptions", "render", "toggleNoTimestampWarning", "blockEverything", "unblockEverything", "updateGrouperCount", "updateFilterCount"

    @model = options.chartModel
    @gaConnectionsCollection = options.gaConnectionsCollection
    @clientId = options.clientId
    @seedTrendId = options.trendId
    @cohortDefault = options.cohortDefault

    @cohortFieldCollection = new rjm.model.CohortFieldCollection [], {clientId: @clientId}

    @viewState = new rjm.ui.ChartBuilderViewState
      chartValidationErrors: {}
      trendsOnly: options.isCreate and options.trendId is 0 #controls the trend selector only vs everything visibility
      isCreate: options.isCreate #controls the save-as button visibility
      isSaving: false
      renderButtons: false
      filtersApplied: true

    #initialize the subviews
    @initializeSubviews()

    @listenTo @viewState, "change:trendsOnly", @unblockEverything
    @listenTo @model.get("series").at(0), "change:trend", @toggleNoTimestampWarning
    @listenTo @model.get("series").at(0), "change:restrictionSet", @updateFilterCount
    @listenTo @model.get("series").at(0), "change:trend", @updateFilterCount
    @listenTo @model.get("series").at(0).get('categorySet'), "add:categorySelectors", @updateGrouperCount
    @listenTo @model.get("series").at(0).get('categorySet'), "remove:categorySelectors", @updateGrouperCount

    @listenTo @model, "standard", @renderStandardOptions
    @listenTo @model, "cohort", @renderCohortOptions

    return

  initializeSubviews: ->
    @chartName = new rjm.ui.ChartBuilderChartNameView(
      chartModel: @model
      viewState: @viewState
    )
    @trendList = new rjm.ui.ChartBuilderTrendListView(
      gaConnectionsCollection: @gaConnectionsCollection
      viewState: @viewState
      model: @model
      clientId: @clientId
      seedTrendId: @seedTrendId
      cohortDefault: @cohortDefault
    )
    @typeSelector = new rjm.ui.ChartBuilderTypeSelectorView(
      chartModel: @model      
    )
    @chartStyle = new rjm.ui.ChartBuilderChartStyleView(
        chartModel: @model
    )
    @timeInterval = new rjm.ui.ChartBuilderTimeIntervalView(
      chartModel: @model
      viewState: @viewState
    )
    @perspectives = new rjm.ui.ChartBuilderSeriesPerspectiveView(
      chartModel: @model
    )
    @buttons = new rjm.ui.ChartBuilderButtonsView(
      chartModel: @model
      viewState: @viewState
    )
    @filters = new rjm.ui.ChartBuilderFiltersView(
      chartModel: @model
      viewState: @viewState
    )
    @categories = new rjm.ui.ChartBuilderDimensionListView(
      chartModel: @model
      viewState: @viewState
    )
    @preview = new rjm.ui.ChartBuilderPreviewView(
      chartModel: @model
      viewState: @viewState
    )

  renderCohortOptions: ->
    #remove any existing click listeners that would close large custom dropdowns
    @$('.chartBuilder').off "click"
    #remove standard time options
    @timeOptions?.remove()

    #hide groupers 
    @$('#cbCategoriesTab').closest('li').hide()
    @$('.nav.nav-tabs a:first').tab("show")

    #create cohort field view and add it before time interval element
    @cohortField = new rjm.ui.ChartBuilderCohortFieldView(
      chartModel: @model
      cohortFieldCollection: @cohortFieldCollection
    )
    @$("#cbTimeInterval").before @cohortField.el
    @cohortField.render()

    #create cohort time options and add it after the time interval element
    @cohortTimeOptions = new rjm.ui.ChartBuilderCohortTimeOptionsView(
      chartModel: @model
    )
    @$("#cbTimeInterval").after @cohortTimeOptions.el
    @cohortTimeOptions.render()

    #create cohort size view and add it after cohort time options view
    @cohortSize = new rjm.ui.ChartBuilderCohortSizeView(
      chartModel: @model
    )
    @$("#cbCohortTime").after @cohortSize.el
    @cohortSize.render()

    @$('.chartBuilder').on('click', (e) =>
      e.preventDefault()
      @cohortTimeOptions.handleExternalClickEvent(e)
      @cohortSize.handleExternalClickEvent(e)
    )

    @cohortMemberSelector = new rjm.ui.ChartBuilderCohortMemberSelectorView
      chartModel: @model
    @$("#cbCohortSize").after @cohortMemberSelector.el
    @cohortMemberSelector.render()

    @timeInterval.render()

    @cohortFieldCollection.setTrendId(@model.getCurrentSeries().get("trend").get("id"))
    @cohortFieldCollection.fetch() #this fetch is here so the cohort field and member selector views both use CohortFieldCollection

    return

  renderStandardOptions: ->
    if @$('#cbTime').length > 0
      return #the dom already has cbTime. does not need to be rendered

    #remove any existing click listeners that would close large custom dropdowns
    @$('.chartBuilder').off "click"
    #remove cohort options from dom
    @cohortField?.remove()
    @cohortTimeOptions?.remove()
    @cohortSize?.remove()
    @cohortMemberSelector?.remove()

    #show groupers 
    @$('#cbCategoriesTab').closest('li').show()

    #create standard time options view and add before time interval view
    @timeOptions = new rjm.ui.ChartBuilderTimeOptionsView
      chartModel: @model
      viewState: @viewState
    @$("#cbTimeInterval").before @timeOptions.el
    @timeOptions.render()

     # Closes the quicklinks box when clicking anywhere except in the quicklinks(timeOptions) view
    @$('.chartBuilder').on 'click', (e) =>
      e.preventDefault()
      @timeOptions.handleExternalClickEvent(e)

    @timeInterval.render()

    return

  render: ->

    parent.$('#cboxClose').hide()

    @$el.html ich.chartBuilderContainer()

    @$('#timestampWarning').hide()

    #render the subviews
    @chartName.setElement(@$("#cbChartName")).render()
    @trendList.setElement(@$("#cbTrendList")).render()
    @timeInterval.setElement(@$("#cbTimeInterval")).render()
    @typeSelector.setElement(@$("#cbType")).render()
    @chartStyle.setElement(@$("#cbChartStyle")).render()
    @trendList.setElement(@$("#cbTrendList")).render()
    @perspectives.setElement(@$("#cbDataPerspective")).render()
    @buttons.setElement(@$("#cbButtons")).render()
    @filters.setElement(@$("#cbFilters")).render()
    @categories.setElement(@$("#cbCategories")).render() 

    if @model.isCohortChart()
      @renderCohortOptions()
    else
      @renderStandardOptions()

    if @viewState.get("trendsOnly")
      @blockEverything()
    else
      @preview.setElement(@$("#cbChart")).render()
      @toggleNoTimestampWarning()

    #update the filter/grouper count on their perspective tabs
    @updateFilterCount()
    @updateGrouperCount()

    return @

  #TODO: move this logic into the timePeriod view (or whichever view this belongs into )
  toggleNoTimestampWarning: ->
    if @model.hasTimestamp()
      @$('#timestampWarning').hide()
    else
      @$('#timestampWarning').show()

  blockEverything: ->
    @timeOptions.block()
    @timeInterval.block()
    @chartName.block()
    @buttons.block()
    @chartStyle.block()
    @filters.block()
    @categories.block()
    @perspectives.block()
    @$('.nav.nav-tabs').each ->
      $(this).children().addClass('blocked')

  unblockEverything: ->
    if @model.hasTimestamp()
      @timeOptions.unblock()
      @timeInterval.unblock()
    @chartName.unblock()
    @buttons.unblock()
    @chartStyle.unblock()
    @filters.unblock()
    @categories.unblock()
    @perspectives.unblock()
    @$('.nav.nav-tabs').each ->
      $(this).children().removeClass('blocked')

    @preview.setElement(@$("#cbChart")).render()

  updateGrouperCount: ->
    @$('#grouperCount').html(@model.get("series").at(0).get('categorySet').get("categorySelectors").size())

  updateFilterCount: ->
    @$('#filterCount').html(@model.get("series").at(0).get('restrictionSet').get("restrictions").size())

)
